<template>
    <div class="content">
        <div class="col-md-8 flex-container-top">
            <base-button type="primary" round icon class="top-button-back" @click="$router.push('list')">
                <i class="fa fa-arrow-left"></i>
            </base-button>

            <h2 v-if="!isEdit" class="text-center">Add Credits bundles</h2>
            <h2 v-if="isEdit" class="text-center">Edit Credits bundles</h2>
        </div>
        <div class="row">
            <div class="col-md-12">
                <card>
                    <form>
                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="Name *" maxlength="50" placeholder="Name"
                                    v-model="top_up_name">
                                </base-input>
                            </div>

                            <div class="col-md-6">
                                <base-input type="text" maxlength="10" label="Cost *" @keyup="onlyNumeric('cost')"
                                    placeholder="Cost" v-model="cost">
                                </base-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <base-input type="text" label="No. of Credits*" maxlength="5"
                                    @keyup="onlyNumeric('money_count')" placeholder="No. of Credits" v-model="money_count">
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <base-button v-if="!isEdit" native-type="submit" type="primary" @click="AddTopUp()"
                                    class="btn-fill" :disabled="loading">Add</base-button>
                            </div>

                            <div style="display: flex; flex-direction: row; justify-content:flex-end;" class="col-md-6">
                                <base-button v-if="isEdit" native-type="submit" type="primary" @click="UpdateTopUp()"
                                    class="btn-fill" :disabled="loading">Update</base-button>
                                <base-button v-if="isEdit" native-type="submit" type="primary"
                                    style="border-radius: 25px;background: #cc0000;" @click="DeleteTopUp()"
                                    class="btn-danger ml" :disabled="loading">
                                    Delete
                                </base-button>
                            </div>
                        </div>
                    </form>
                </card>
            </div>
        </div>
        <div class="full-screen-loader" v-if="loading">
            <div class="sk-chase">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            active_status: true,
            top_up_name: "",
            cost: "",
            money_count: "",
            isEdit: false,
            loading: false,
        };
    },

    async mounted() {
        console.log(this.$route.query.id);
        var id = this.$route.query.id;

        if (id == -1) {
            this.isEdit = false;
        } else {
            this.isEdit = true;
            let creditsBundle = await this.$apiService.getCall("dropintopup/get-dropInTopUpbyId/" + id);
            if (creditsBundle.apidata.Code === "P00001") {
                this.active_status = creditsBundle.apidata.Data.active_status;
                this.top_up_name = creditsBundle.apidata.Data.name;
                this.cost = creditsBundle.apidata.Data.cost;
                this.money_count = creditsBundle.apidata.Data.money_count;
            } else {
                this.$apiService.notify(creditsBundle.apidata.Message);
            }
        }
    },

    methods: {
        async UpdateTopUp() {

            var id = this.$route.query.id;
            if (!this.top_up_name && !this.cost && !this.money_count) {
                this.$apiService.notify("All fields are mandatory.");
                return;
            }
            if (!this.top_up_name) {
                this.$apiService.notify("Name is mandatory.");
                return;
            }
            if (!this.cost) {
                this.$apiService.notify("Cost is mandatory.");
                return;
            }
            if (!this.money_count) {
                this.$apiService.notify("No. of Credits is mandatory.");
                return;
            }
            this.loading = true;

            var TopUpData = {
                name: this.top_up_name,
                money_count: this.money_count,
                cost: this.cost,
            };

            var update_top_up = await this.$apiService.postCall(
                "dropintopup/update-dropintopup/" + id,
                TopUpData
            );
            console.log(update_top_up);

            this.$apiService.notify("Pass has been updated.");
            this.$router.push("/creditsbundles");
        },

        async AddTopUp() {
            if (!this.top_up_name && !this.cost && !this.money_count) {
                this.$apiService.notify("All fields are mandatory.");
                return;
            }
            if (!this.top_up_name) {
                this.$apiService.notify("Name is mandatory.");
                return;
            }
            if (!this.cost) {
                this.$apiService.notify("Cost is mandatory.");
                return;
            }
            if (!this.money_count) {
                this.$apiService.notify("No. of Credits is mandatory.");
                return;
            }

            this.loading = true;

            var add_credits_bundele = await this.$apiService.postCall("dropintopup/add-dropintopup", {
                name: this.top_up_name,
                money_count: this.money_count,
                cost: this.cost
            });
            console.log(add_credits_bundele);
            if (add_credits_bundele.apidata.Code === "P00001") {
                this.$apiService.notify("Credits bundle has been added.");
                this.$router.push("/creditsbundles");
            } else {
                this.$apiService.notify(add_credits_bundele.apidata.Message);
            }
            this.loading = false;
        },

        async DeleteTopUp() {
            const id = this.$route.query.id;
            const del_credits_bundle = await this.$apiService.postCall(
                "dropintopup/delete-dropintopup/" + id,
            );
            if (del_credits_bundle.apidata.Code === "P00001") {
                this.$apiService.notify("Credits bundle has been deleted.");
                this.$router.push("/creditsbundles");
            } else {
                this.$apiService.notify(del_credits_bundle.apidata.Message);
            }
        },

        onlyNumeric(field) {
            let value = this[field];

            value = value.replace(/[^0-9.]/g, '');

            if (value.startsWith('.')) {
                value = '';
            }

            value = value.replace(/(\..*)\./g, '$1');

            if (value.includes('.')) {
                const parts = value.split('.');
                parts[1] = parts[1].slice(0, 2);
                value = parts[0] + '.' + parts[1];
            }

            value = value.replace(/^0+(?!\.)/, '');

            this[field] = value;
        },
    }
};
</script>

<style>
.location {
    background: #27293d;
    border: 1px solid #2b3553;
    padding: 8px;
    font-size: 14px;
    border-radius: 5px;
    width: 100%;
    color: white;
}

form label {
    font-weight: 600;
}

.my-override {
    padding: inherit;
    line-height: inherit;
    border: revert;
    border-radius: 0.4285rem;
    border-color: #2b3553;
}

.coordinate {
    background: #27293d;
    border: 1px solid #2b3553;
    padding: 5px;
    font-size: 14px;
    border-radius: 5px;
    /* width: 100%; */
    color: white;
}

.radio-item input[type="radio"]:checked+label:after {
    border-radius: 11px;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 9px;
    left: 19px;
    content: " ";
    display: block;
    background: #e14eca;
}

.radio-item {
    display: inline-block;
    position: relative;
    padding: 0 15px;
    margin: 10px 0 0;
}

.radio-item input[type="radio"] {
    display: none;
}

.radio-item label {
    color: white;
    font-weight: 600;
}

.radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    border: 2px solid white;
    background-color: transparent;
}
</style>
